import { render, staticRenderFns } from "./ItemTabImages.vue?vue&type=template&id=015efd96&scoped=true"
import script from "./ItemTabImages.vue?vue&type=script&lang=ts"
export * from "./ItemTabImages.vue?vue&type=script&lang=ts"
import style0 from "./ItemTabImages.vue?vue&type=style&index=0&id=015efd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015efd96",
  null
  
)

export default component.exports